import React, { SVGProps } from 'react'
const SvgPeopleSingle = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || '#B3B7BE'}
      stroke={props.stroke || '#B3B7BE'}
      strokeWidth={0.25}
      d="M9.977 10.963a3.73 3.73 0 0 0-2.102 3.357v1.75a2.914 2.914 0 0 0 2.905 2.915h3.01c1.6 0 2.905-1.306 2.905-2.915v-1.75a3.726 3.726 0 0 0-2.098-3.348c.67-.779.976-1.887.582-3.062a3 3 0 0 0-1.911-1.88 3.077 3.077 0 0 0-4.053 2.92c0 .75.271 1.439.72 1.97l.007.008.035.035Zm3.464-.367-.01.007-.01.008a.072.072 0 0 1-.012.01l-.015.01-.023.015a1.955 1.955 0 0 1-1.091.319c-.404 0-.76-.122-1.06-.328l-.01-.008-.014-.005a.454.454 0 0 1-.101-.064l-.006-.004-.028-.018-.002-.002a1.617 1.617 0 0 1-.021-.013.18.18 0 0 1-.03-.022l-.01-.009a1.982 1.982 0 0 1-.676-2.043c.169-.695.744-1.28 1.438-1.458a2.035 2.035 0 0 1 2.545 1.959c0 .638-.309 1.22-.778 1.588l-.041.028-.045.03Zm2.254 5.474a1.909 1.909 0 0 1-1.905 1.915h-3.01a1.909 1.909 0 0 1-1.905-1.915v-1.75a2.73 2.73 0 0 1 2.02-2.637c.417.215.882.332 1.385.332s.977-.117 1.395-.332a2.73 2.73 0 0 1 2.02 2.637v1.75Z"
    />
  </svg>
)
export default SvgPeopleSingle
